import React from 'react';
import { User, Building2, Target, BarChart3 } from 'lucide-react';

const CommTargetSummary = ({ target }) => {
  if (!target || !target.name) return null;

  const fields = [
    { icon: <User size={12} />, label: 'Nom', value: target.name },
    { icon: <Building2 size={12} />, label: 'Rôle', value: target.role },
    { icon: <Building2 size={12} />, label: 'Organisation', value: target.organization },
    { icon: <Target size={12} />, label: 'Domaine', value: target.domain },
    { icon: <BarChart3 size={12} />, label: 'Objectif', value: target.objective },
  ].filter(f => f.value);

  const completeness = target.completeness || 0;

  return (
    <div style={{
      background: 'var(--card-bg)', border: '1px solid var(--card-border)',
      borderRadius: 10, padding: '10px 14px', marginBottom: 8,
      borderLeft: '3px solid #8b5cf6',
    }}>
      <div style={{ fontSize: 11, fontWeight: 600, color: '#8b5cf6', marginBottom: 6, display: 'flex', alignItems: 'center', gap: 6 }}>
        <Target size={12} />
        Cible — {completeness}% complétée
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 12px' }}>
        {fields.map((f, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 11, color: 'var(--text-secondary)' }}>
            {f.icon}
            <span style={{ color: 'var(--text)', fontWeight: 500 }}>{f.value}</span>
          </div>
        ))}
      </div>
      {/* Barre de progression */}
      <div style={{ height: 3, background: 'var(--input-border)', borderRadius: 2, marginTop: 8, overflow: 'hidden' }}>
        <div style={{ height: '100%', width: `${completeness}%`, background: '#8b5cf6', borderRadius: 2, transition: 'width 0.3s' }} />
      </div>
    </div>
  );
};

export default CommTargetSummary;
